import { Component, OnInit, Inject, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { MatCalendar } from '@angular/material/datepicker';

export interface FiltersDialogState {
  nombre: string;
  genero: string | null;
  horaInicio: number;
  horaInicioIsPm: boolean;
  horaFin: number;
  horaFinIsPm: boolean;
  daysSelected: string[];
}

@Component({
    selector: 'app-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FiltersComponent implements OnInit {

  @ViewChildren('calendar') calendar: MatCalendar<any>;

  minDate;
  maxDate;
  public daysSelected: any[] = [];
  event: any;
  // filtros
  nombre = "";
  genero = null;
  horaInicio = 9;
  horaInicioIsPm = false;
  horaFin = 7;
  horaFinIsPm = true;

  calendario;

  // variable calendario
  fechaCalendario = "";

  horas = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  private readonly defaultState: FiltersDialogState = {
    nombre: '',
    genero: null,
    horaInicio: 9,
    horaInicioIsPm: false,
    horaFin: 7,
    horaFinIsPm: true,
    daysSelected: [],
  };

  constructor(
    public dialogRef: MatDialogRef<FiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  isSelected = (event: any) => {
    const date =
      event.getFullYear() +
      "-" +
      ("00" + (event.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + event.getDate()).slice(-2);
    return this.daysSelected.find(x => x == date) ? "selected" : null;
  };

  select(event: any, calendar: any) {
    const date =
      event.getFullYear() +
      "-" +
      ("00" + (event.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + event.getDate()).slice(-2);
    const index = this.daysSelected.findIndex(x => x == date);
    if (index < 0) this.daysSelected.push(date);
    else this.daysSelected.splice(index, 1);
    console.log(calendar)
    this.calendario = calendar;
    calendar.updateTodaysDate();
  }

  ngOnInit(): void {
    this.minDate = moment().format();
    this.maxDate = moment().format();

    const filters = this.data?.filters || this.data || {};
    this.applyState(filters);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  buscar() {
    const datesSort = [...this.daysSelected].sort();
    const data = {
      nombre: this.nombre,
      genero: this.genero,
      horaInicio: this.horaInicioIsPm ? Number(this.horaInicio)+12 : this.horaInicio,
      horaInicioIsPm: this.horaInicioIsPm,
      horaFin: this.horaFinIsPm ? Number(this.horaFin)+12 : this.horaFin,
      horaFinIsPm: this.horaFinIsPm,
      fechaInicio: this.daysSelected.length > 0 ? datesSort[0] : '',
      fechaFin: this.daysSelected.length > 0 ? datesSort[datesSort.length - 1] : '',
      daysSelected: [...datesSort],
      hasFilters: this.hasAnyFilter(),
    }
    this.dialogRef.close({ action: 'search', filters: data });

  }

  clearFilters(){
    this.applyState(this.defaultState);
    if(this.calendario){
      this.calendario.updateTodaysDate();
    }
    this.dialogRef.close({ action: 'clear' });
  }

  private applyState(state: Partial<FiltersDialogState>): void {
    const merged = {
      ...this.defaultState,
      ...state,
    };

    this.nombre = merged.nombre || '';
    this.genero = merged.genero ?? null;
    this.horaInicio = Number.isFinite(Number(merged.horaInicio)) ? Number(merged.horaInicio) : this.defaultState.horaInicio;
    this.horaInicioIsPm = !!merged.horaInicioIsPm;
    this.horaFin = Number.isFinite(Number(merged.horaFin)) ? Number(merged.horaFin) : this.defaultState.horaFin;
    this.horaFinIsPm = !!merged.horaFinIsPm;
    this.daysSelected = Array.isArray(merged.daysSelected) ? [...merged.daysSelected] : [];
  }

  private hasAnyFilter(): boolean {
    return !!(
      this.nombre?.trim() ||
      this.genero ||
      this.daysSelected.length > 0 ||
      this.horaInicio !== this.defaultState.horaInicio ||
      this.horaInicioIsPm !== this.defaultState.horaInicioIsPm ||
      this.horaFin !== this.defaultState.horaFin ||
      this.horaFinIsPm !== this.defaultState.horaFinIsPm
    );
  }
}
